<template>
    <div class="list--view responsive-element">

        <div data-toggle="tooltip" data-placement="top" title="Filtra per anagrafiche attive o storiche"
            class="single--list-view single--list-view-employees">
            <span class="pre-filter-label"> Filtri</span>
            <vs-select class="selectExample" v-model="selectTypeEmployees" @input="statusSelected">
                <vs-select-item :is-selected="item.isSelected" :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in optionsTypeEmployees" />
            </vs-select>
        </div>

        <div data-toggle="tooltip" data-placement="top" title="Filtra per tipologia" class="single--list-view single--list-view-roles">
            <vs-select class="selectExample" v-model="selectTypeRoles" @input="typologySelected">
                <vs-select-item :is-selected="item.isSelected" :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in optionsTypeRoles" />
            </vs-select>
        </div>
        <div data-toggle="tooltip" data-placement="top" title="Filtra per sede" class="single--list-view single--list-view-roles">
            <vs-select class="selectExample" v-model="selectHeadquarters" @input="headquarterSelected">
                <vs-select-item :is-selected="item.isSelected" :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in optionsHeadquarters" />
            </vs-select>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectTypeEmployees: (location.search.indexOf("resigned_at") >= 0 && /resigned_at=([^&]+)/.exec(location.href)[1] === "1") ? "hystorical" : "actual",
            selectTypeRoles: /typology=([^&]+)/.exec(location.href) == null ? "" : /typology=([^&]+)/.exec(location.href)[1],
            selectHeadquarters: /headquarter=([^&]+)/.exec(location.href) == null ? "" : /headquarter=([^&]+)/.exec(location.href)[1], //
            optionsTypeEmployees: [
                { value: 'actual', label:this.__('misc.actuals'), isSelected: false },
                { value: 'hystorical', label:this.__('misc.history'), isSelected: false },
            ],
            optionsTypeRoles: [],
            optionsHeadquarters: [],

        }
    },
    methods: {
        statusSelected(selectedOption, id) {
            if (selectedOption == "actual") {
                location.href = app.__vue__.addParam("resigned_at", "0");
            } else if (selectedOption == "hystorical") {
                location.href = app.__vue__.addParam("resigned_at", "1");
            }
        },
        typologySelected(selectedOption, id) {

            if (selectedOption === '') {
                location.href = "/people";
            }
            else {
                location.href = app.__vue__.addParam('typology', selectedOption);
            }
        },
        headquarterSelected(selectedOption, id) {


            if (selectedOption === '') {
                location.href = "/people";
            }
            else {

                location.href = app.__vue__.addParam('headquarter', selectedOption);
            }
        },
        loadTypologies() {
            axios
                .get("/getTypology")
                .then(response => {
                    //this.datas = response.data;
                    this.optionsTypeRoles = response.data;
                });
        },
        loadHeadquarters() {
            axios
                .get("/getHeadquarters")
                .then(response => {
                    //this.datas = response.data;
                    this.optionsHeadquarters = response.data;
                });
        }
    },
    mounted() {
        this.loadTypologies();
        this.loadHeadquarters();

    }

}
</script>
